'use strict';

const BaseModel = require('./baseModel');

class JobRequest extends BaseModel {
  constructor() {
    super(jobRequestSchema);
  }

  static getSchema() {
    return jobRequestSchema;
  }
}

const jobRequestSchema = {
  position: {
    industryTypeId: {
      required: {
        message: 'This field is required.'
      }
    },
    segmentTypeId: {
      required: {
        message: 'This field is required.'
      }
    },
    positionTypeId: {
      required: {
        message: 'This field is required.'
      }
    },
    licenseRequired: {
      required: {
        message: 'This field is required.'
      }
    },
    dualMonitorsRequired: {
      required: {
        message: 'This field is required.'
      }
    },
    outsideContactRequired: {
      required: {
        message: 'This field is required.'
      }
    },
    numberOfPeople: {
      required: {
        message: 'This field is required.'
      },
      isInt: {
        options: { min: 1 },
        message: 'Must be positive numeric.'
      }
    },
    fromDifferentOffice: {
      required: {
        message: 'This field is required.'
      }
    }
  },
  description: {
    required :{
      message :'This field is required.'
    }
  },
  workschedule: {
    jobTypeId :{
      required :{
        message :'This field is required.'
      }
    },
    numberOfMonths:{},
    dateEnded:{},
    dateStarted:{

    },
    estimatedHoursPerWeek:{
      required :{
        message :'This field is required.'}
    },
    partTimeWahvesConsidered:{

    },
    workdays:{
      required :{
        message :'This field is required.'}
    },
    offHoursConsidered:{
      required :{
        message :'This field is required.'}
    },
    timezone:{
      required :{
        message :'This field is required.'}
    },
    startTime:{
      required :{
        message :'This field is required.'}
    },
    endTime:{
      required :{
        message :'This field is required.'}
    }
  },
  addcontact: {
    contacts: {
      required :{
        message :'This field is required.'
      }
    }
  },
  skillOptions: {
    categoryId: {
      required :{
        message :'This field is required.'
      }
    },
    name: {
      required :{
        message :'This field is required.'
      }
    },
    skillOption: {
      required :{
        message :'This field is required.'
      }
    }
  }
};
module.exports = JobRequest;



// WEBPACK FOOTER //
// ./shared/models/jobRequest.js